import React from "react";

const UserReportCardSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col gap-y-2 p-2 md:p-4 border border-[#BCC1CA] rounded-[6px] shadow-[0px_0px_1px_0px_#171A1F12] shadow-[0px_0px_2px_0px_#171A1F1F] w-full xs:w-[calc(50%-8px)] max-w-[281px] cursor-not-allowed">
      {/* Report badge skeleton */}
      <div className="w-full h-[140px] animate-pulse bg-[#D9D9D9] rounded-[4px]" />

      <div className="flex flex-col gap-2">
        {/* Status skeleton */}
        <div className="h-[26px] w-[120px] animate-pulse bg-[#D9D9D9] rounded-[4px]" />

        {/* Date skeleton */}
        <div className="h-[16px] w-[100px] animate-pulse bg-[#D9D9D9] rounded-[4px]" />

        {/* Case name skeleton */}
        <div className="h-[16px] w-[150px] animate-pulse bg-[#D9D9D9] rounded-[4px]" />
      </div>
    </div>
  );
};

export default UserReportCardSkeleton;
